import { useAuth } from "@clerk/react";
import { useApprovalStatus } from "@/hooks/use-approval-status";

/**
 * Returns true if the current signed-in user is an admin.
 *
 * Reuses the canonical useApprovalStatus hook so this observer registers the
 * SAME queryKey + SAME queryFn reference + SAME return shape as RoleGate's
 * observer. Sharing the exact fetcher prevents TanStack Query observer
 * collisions that previously caused approval-status data to be overwritten
 * by a thinner {isAdmin} payload, which in turn made RoleGate flip between
 * Redirect targets and trigger an infinite useEffect loop in Wouter's
 * <Redirect> component.
 */
export function useIsAdmin(): boolean {
  const { isSignedIn, isLoaded } = useAuth();
  const { data } = useApprovalStatus(isLoaded && isSignedIn === true);
  return Boolean(data?.isAdmin);
}
